import axios from 'axios';
import url from '../constants/url';
import {getLocale} from '@epic-core/common';

export const getPageData = async cmsUrlPattern => {
    const locale = getLocale();
    if (!locale || !cmsUrlPattern) {
        throw new Error('getPageData() requires a locale and a cmsUrlPattern');
    }
    const api = url().CMS_PAGE_DATA(locale, cmsUrlPattern);
    console.log('CmSource.getPageData() trying', api);
    let response = {};
    try {
        response = await axios(api);
    } catch (e) {
        console.error('CmsSource.getPageData() failed to load cms page', cmsUrlPattern);
        console.error(e.message);
    }
    const data = response.data || {};
    if (response.status === 200 && typeof data === 'object' && data._urlPattern) {
        return data;
    }
    console.error('CmsSource.getPageData() response was not an object or did not contain the _urlPattern field', response.status);
    return null;
};

export const getRootPageData = (locale, cmsUrlPattern) => {
    const api = url().CMS_ROOTPAGE_DATA(locale, cmsUrlPattern);
    return axios(api).catch(e => {
        console.error('CmsSource.getRootPageData() failed to load cms page', cmsUrlPattern);
        console.error(e.message);
    });
};
